module.exports = __webpack_public_path__ + "img/TurningStool6.a13087db.jpg";